export default "__VITE_ASSET__DfEDJO5e__"